package `fun`.adaptive.adaptive_lib_document.generated.resources

import `fun`.adaptive.resource.graphics.Graphics
import `fun`.adaptive.resource.graphics.GraphicsResource
import `fun`.adaptive.resource.graphics.GraphicsResourceSet

private object commonMainGraphics0 {

    val book_3 by lazy { init_book_3() }

}

val Graphics.book_3
    get() = commonMainGraphics0.book_3

private fun init_book_3() =
    GraphicsResourceSet(
        name = "book_3",
        GraphicsResource("/fun.adaptive.adaptive_lib_document.generated.resources/graphics/book_3.svg", setOf())
    )